<template>
    <div v-if="bizAuth.viewLedger.hasRight" class="page-setting ledger-mgt parent-frame" :class="{'fixed': listIsFixed}"  v-bind:style="{'min-height': myHeight}">
        <div class="tool-bar-mask"></div>
        <!-- <new-ledger></new-ledger> -->
        <Breadcrumb />
        <div class="page-header has-tab">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <table-search @changeWord="setFilterWord" ></table-search>
                <div class="filter" @click="openFilter()">
                    <img src="@/assets/img/icon/filter_black.svg" alt="">
                </div>
                <div v-if="bizAuth.createLedger.hasRight"  class="default-button new-accounting-btn" @click="$router.push({name: 'bizNewLedger'})">
                    新增記帳
                </div>
            </div>
        </div>
        <tabs :key="componentKey">
            <tab name="今日" :selected="selected.today" >
            </tab>
            <tab name="近七天" :selected="selected.week" >
            </tab>
            <tab name="近一個月" :selected="selected.month" >
            </tab>
            <tab name="本季" :selected="selected.season" >
            </tab>
            <tab name="今年" :selected="selected.year" >
            </tab>
        </tabs>
        <ledger-mgt-filter :isOpen="isFilter" @filterClose="closeFilter" @changeFilter="setFilterQuery"></ledger-mgt-filter>
        <ledger-total></ledger-total>
        <ledger-mgt :isLoading="isLoading"></ledger-mgt>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import Tabs from '@/components/widge/Tabs.vue';
import Tab from '@/components/widge/Tab.vue';
import ledgerMgt from '@/components/bussiness/financialReport/ledgerMgt/ledgerMgt.vue';
import ledgerTotal from '@/components/bussiness/financialReport/ledgerMgt/ledgerTotal.vue';
import ledgerMgtFilter from '@/components/bussiness/financialReport/ledgerMgt/ledgerMgtFilter.vue';
import TableSearch from '@/components/widge/TableSearch.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            hash: null,
            myHeight: (window.innerHeight) + 'px',
            listIsFixed: false,
            isFilter: false,
            selected: {
                today: false,
                week: false,
                month: false,
                season: false,
                year: true,
            },
            componentKey: 0,
            isLoading: true
        }
    },
    created (){
        // console.log(this.$route)
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        $route:{
            handler: function (val) {
                this.hash = val.hash
                this.forceUpdate()
            },
            immediate: true,
            deep: true
        },
        isModalMode: function (val) {
            if(val){
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '9'
            }else{
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }
            
        },
        'bizAuth.viewLedger.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            if(!this.isModalMode){
                let scrollTop = event.target.documentElement.scrollTop
                if( scrollTop >= 50){
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                }else{
                    document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                    document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                    this.listIsFixed = false
                }

                if( scrollTop >= 115){
                    this.listIsFixed = true
                }
            }
        },
        selectTabByHash: function () {
            let hashTag = decodeURIComponent(this.$route.hash)

            if( hashTag == '#今日' ){
                this.selected.today = true
                this.$store.dispatch('getBizLedgerMgtList', 'DAY')
                .then(()=>{
                    this.isLoading = false
                })
            }else if( hashTag == '#近七天' ){
                this.selected.week = true
                this.$store.dispatch('getBizLedgerMgtList', 'WEEK')
                .then(()=>{
                    this.isLoading = false
                })
            }else if( hashTag == '#近一個月' ){
                this.selected.month = true
                this.$store.dispatch('getBizLedgerMgtList', 'MONTH')
                .then(()=>{
                    this.isLoading = false
                })
            }else if( hashTag == '#本季' ){
                this.selected.season = true
                this.$store.dispatch('getBizLedgerMgtList', 'SEASON')
                .then(()=>{
                    this.isLoading = false
                })
            }else if( hashTag == '#今年' ){
                this.selected.year = true
                this.$store.dispatch('getBizLedgerMgtList', 'YEAR')
                .then(()=>{
                    this.isLoading = false
                })
            }else{
                this.selected.year = true
                this.$store.dispatch('getBizLedgerMgtList', 'YEAR')
                .then(()=>{
                    this.isLoading = false
                })
            }
        },
        setSelectTabAllFalse: function () {
            this.selected.today = false
            this.selected.week = false
            this.selected.month = false
            this.selected.season = false
            this.selected.year = false
        },
        forceUpdate: function () {
            this.setSelectTabAllFalse()
            this.selectTabByHash()
            this.componentKey += 1; 
        },
        openFilter: function () {
            this.isFilter = true
            this.$store.commit('modalStatus/set_filter_mode', true)
            document.getElementsByClassName('ledger-mgt')[0].style.zIndex = '8'
        },
        closeFilter: function (value) {
            this.isFilter = value
            this.$store.commit('modalStatus/set_filter_mode', false)
        },
        setFilterWord: function (value) {
            this.$store.dispatch('setBizLedgerMgtFilterWord', value)
        },
        setFilterQuery: function (value) {
            console.log(value)
            this.$store.dispatch('setBizLedgerMgtFilterQuery', value)
        },
        newLedger: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.$analyticsBiz.logEvent('新增記帳', { screen_name: '新增記帳'})
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNewLedger'})
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
    },
    computed: {
        ...mapGetters({
            isModalMode: 'GET_MODAL_MODE',
            bizAuth: 'GET_BIZ_AUTH',
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED'
        })
    },
    components: {
        ledgerMgt,
        ledgerMgtFilter,
        TableSearch,
        Breadcrumb,
        ledgerTotal,
        Tabs,
        Tab,
    }
}
</script>
<style lang="scss">
    .ledger-mgt{
        .page-header{
            .btn-group{
                .new-accounting-btn{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-sizing: border-box;
                    width: 120px;
                    padding: 10px 0;
                    font-weight: 500;
                }
            }
        }
    }
 
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/financialReport/ledgerMgt/ledgerMgtDefault.vue